import { map, flow, flatMap, filter, keys, sortBy } from 'lodash/fp';

import { isTableType } from 'constants/chart-roles';
import { CHANNEL_TYPE_ENUM } from 'constants/chart-channels';

import { generatePostProcessedSelectors } from 'utils/process-spec-and-data/post-agg-sorting';

function sortTableDocuments(stageData) {
  const {
    environment: { chartType, channels },
    documents,
  } = stageData;

  // don't sort the documents by group if not available.
  if (!isTableType(chartType)) {
    return {};
  }

  const groupColumnsOrdering = flow(
    keys,
    filter(
      channel => channels[channel].channelType === CHANNEL_TYPE_ENUM.CATEGORY
    ),
    map(channel => [
      channel,
      generatePostProcessedSelectors(channels[channel]),
    ]),
    flatMap(([channel, selectors]) =>
      selectors.map(selector => doc => selector(doc[channel]))
    )
  )(channels);

  const sortedDocuments = sortBy(groupColumnsOrdering, documents);

  return {
    documents: sortedDocuments,
  };
}

export default {
  input: ['environment.chartType', 'environment.channels', 'documents'],
  fn: sortTableDocuments,
};
export { sortTableDocuments };
